import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.COMMERCIAL}/`;

export const GetCommercialByExternalIdAPI = ({
  externalId,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}${externalId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
